<cr-panel>
	<cr-panel-header>
		<!--  -->
		<cls-spinner
			style="margin-right: 8px"
			title="Spinner"
			*ngIf="previews?.length && isLoadingResults"
			width="20px"></cls-spinner>
		<!--  -->
		{{ translations?.RESULTS_SECTION?.TITLE || 'Results' }}
		<ng-container *ngIf="focusedMatch">
			({{ visibleResults.length }} {{ translations?.SHARED?.OF || 'of' }} {{ previews?.length }})
		</ng-container>
		<!--  -->
	</cr-panel-header>
	<cr-panel-actions>
		<cr-panel-action *ngIf="focusedMatch">
			<ng-container *ngTemplateOutlet="menu__show_results"></ng-container>
		</cr-panel-action>
		<cr-panel-action *ngIf="isMobile">
			<button mat-button [disabled]="!previews" (click)="isActive = !isActive" aria-label="expend actions">
				<mat-icon [svgIcon]="isActive ? 'arrow_downward' : 'arrow_upward'"></mat-icon>
			</button>
		</cr-panel-action>
		<cr-panel-action *ngIf="!isMobile || isActive">
			<div id="cr-hint-results-filter-list"></div>
			<button
				title="Filter results"
				tabindex="0"
				role="button"
				mat-button
				[ngClass]="{ 'mat-stroked-button mat-warn': hiddenResults.length }"
				[disabled]="!previews || hasOverlay"
				[matTooltip]="
					hiddenResults.length
						? hiddenResults.length + (translations?.RESULTS_SECTION?.FILTERED_RESULTS_TOOLTIP || ' results are hidden')
						: translations?.RESULTS_SECTION?.FILTER_TOOLTIP || 'Filter results'
				"
				(click)="openFilterDialog()"
				aria-label="Opens a dialog to filter out results from report.">
				<mat-icon [svgIcon]="hiddenResults.length ? 'filter_list_color_red' : 'filter_list'"></mat-icon>
			</button>
		</cr-panel-action>
	</cr-panel-actions>
	<cr-panel-body fxLayout="column" fxFlex="100">
		<div id="cr-hint-results-card"></div>
		<ng-container *ngIf="hasOverlay">
			<div class="overlay-component-wrapper">
				<ng-container #vcr></ng-container>
			</div>
		</ng-container>
		<cr-plagiarism-free
			*ngIf="previews && previews.length === 0"
			[ngClass]="hasOverlay ? 'blur' : ''"></cr-plagiarism-free>
		<div
			*ngIf="previews"
			[ngClass]="hasOverlay ? 'blur' : ''"
			fxFlex
			style="overflow-y: auto; height: 100%;">
			<cr-result-card *ngFor="let preview of (previews | whitelist : 'id' : focusedMatch?.ids)" [preview]="preview"></cr-result-card>
		</div>
		<div *ngIf="!previews" [ngClass]="hasOverlay ? 'blur' : ''" fxFlex style="overflow-y: auto; height: 100%;">
			<cr-result-card *ngFor="let item of [1, 2, 3, 4]"></cr-result-card>
		</div>
		<div class="powered-by-section">
			<cr-powered-by></cr-powered-by>
		</div>
	</cr-panel-body>
</cr-panel>
<ng-template #menu__show_results>
	<button
		aria-label="Clear focused results"
		[title]="translations?.RESULTS_SECTION?.CLEAR_FILTER || 'Clear focused'"
		mat-button
		(click)="clearFocusedMatch()"
		[matTooltip]="translations?.RESULTS_SECTION?.CLEAR_FILTER || 'Clear focused'">
		<mat-icon>close</mat-icon>
	</button>
</ng-template>

<ng-template #skeleton__fakes>
	<cr-result-card></cr-result-card>
	<cr-result-card></cr-result-card>
	<cr-result-card></cr-result-card>
</ng-template>
